// extracted by mini-css-extract-plugin
export default {"orderTabContainer":"order-tab_orderTabContainer__0C2lS"};